import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchBookingEvents } from '@/renderer/services/accommodationService';

export function useBookingEvents(bookingId: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.accommodation.bookingEvents(bookingId ?? ''),
    queryFn: () => fetchBookingEvents(bookingId!),
    enabled: !!bookingId,
  });
}
